import { render, staticRenderFns } from "./LivePreview.vue?vue&type=template&id=1bca0fac&scoped=true&"
import script from "./LivePreview.vue?vue&type=script&lang=js&"
export * from "./LivePreview.vue?vue&type=script&lang=js&"
import style0 from "./LivePreview.vue?vue&type=style&index=0&id=1bca0fac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca0fac",
  null
  
)

export default component.exports